<template>
  <div id="bg">
    <img src="/backgrounds/Header_gruen_1920x1080pixel.webp" />
  </div>

  <div class="d-flex justify-center authComp" data-testid="app.auth-component">
    <div class="d-flex flex-column align-center my-auto">
      <img src="/logos/itemis_CREATE_Logo_h_weiss_RGB.svg" style="width: 300px; height: 100px" class="mt-5" />
      <div class="text-h5 text-white mb-8">state machines made easy</div>
      <div class="pa-5 bg-white">
        <div class="d-flex flex-column">
          <p class="mb-3 text-center">You're currently signed out.</p>
          <v-btn v-if="!hideSignIn" @click="login">Sign In</v-btn>
        </div>
        <div class="d-flex justify-center pt-5 px-5">
          <a
            class="legalLink"
            href="https://legal.itemis.com/revisions/products-saas-eval/latest/terms_of_use_EN.html"
            target="_blank"
          >
            itemis AG terms & conditions
          </a>
        </div>
      </div>
      <span style="opacity: 0">___</span>
    </div>
  </div>
  <status-bar />
</template>

<script setup lang="ts">
import StatusBar from "../StatusBar/StatusBar.vue";
import router from "../../router";
import { authStore } from "../../stores/authStore";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";

const hideSignIn = computed(() => useRoute().query.source === "vscode");

onMounted(() => {
  if (authStore.getters.oidcIsAuthenticated && !hideSignIn.value) {
    router.push("/home");
  }
});

async function login() {
  router.push("/home");
}
</script>

<style scoped>
#bg {
  position: fixed;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
}
#bg img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  min-width: 50%;
  min-height: 50%;
}
.authComp {
  z-index: 2;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: auto;
}

.legalLink {
  color: rgba(var(--v-theme-primary));
}
</style>
